function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-145 -177) translate(145 177)"
}, React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  transform: "rotate(-90 16 16)"
}), React.createElement("g", {
  fill: "#292929"
}, React.createElement("path", {
  d: "M4.613 3.21l.094.083L10 8.585l5.293-5.292c.39-.39 1.024-.39 1.414 0 .36.36.388.928.083 1.32l-.083.094L11.415 10l5.292 5.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083L10 11.415l-5.293 5.292c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L8.585 10 3.293 4.707c-.39-.39-.39-1.024 0-1.414.36-.36.928-.388 1.32-.083z",
  transform: "translate(6 6)"
})))));

var SvgCircleCancel = function SvgCircleCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircleCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-cancel.11b1a17d.svg";
export { ForwardRef as ReactComponent };